import React, { useState } from 'react';
import PropTypes from 'prop-types';

const OverlayContext = React.createContext(null);

export const OverlayProvider = (props) => {
    const [config, setOverlayConfig] = useState(null);

    const getOverlayConfig = () => {
        if (config) {
            return {
                ...config,
                onClose: () => setOverlayConfig(null),
                isShown: true,
            };
        }

        return config;
    };

    return (
        <OverlayContext.Provider value={{ setOverlayConfig, getOverlayConfig }}>
            {props.children}
        </OverlayContext.Provider>
    );
};

OverlayProvider.propTypes = {
    children: PropTypes.node,
};

export default OverlayContext;
